import { useNavigate } from "react-router-dom";
const NoMatch = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h1>Page not found</h1>
      <button className="go-back" onClick={() => navigate(-1)}>
        Go Back
      </button>
    </div>
  );
};

export default NoMatch;
